import { type ParentComponent } from "solid-js"
import { A } from "@solidjs/router"
import { useAuth } from "../lib/auth"
import { HeaderTarget } from "./HeaderSlot"

export const Layout: ParentComponent = (props) => {
  const { user, logout } = useAuth()

  return (
    <div class="h-screen bg-gray-50 flex flex-col overflow-hidden">
      <header class="h-14 bg-white border-b border-gray-200 flex items-center px-4 justify-between shrink-0 z-20">
        <div class="flex items-center gap-6">
          <h1 class="text-lg font-bold text-gray-900 tracking-tight">Eckersdorf</h1>
          <nav class="flex items-center gap-1">
            <A
              href="/schedule"
              class="px-3 py-1.5 rounded-md text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors"
              activeClass="bg-gray-100 text-gray-900"
            >Harmonogram</A>
            <A
              href="/workers"
              class="px-3 py-1.5 rounded-md text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors"
              activeClass="bg-gray-100 text-gray-900"
            >Pracownicy</A>
            <A
              href="/stores"
              class="px-3 py-1.5 rounded-md text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors"
              activeClass="bg-gray-100 text-gray-900"
            >Sklepy</A>
          </nav>
        </div>

        <HeaderTarget />

        <div class="flex items-center gap-3">
          <span class="text-sm font-medium text-gray-700">
            {user()?.firstName} {user()?.lastName}
          </span>
          <button
            onClick={logout}
            class="text-sm text-gray-500 hover:text-gray-900 px-2 py-1 rounded hover:bg-gray-100 transition-colors"
          >
            Wyloguj
          </button>
        </div>
      </header>

      <main class="flex-1 flex flex-col overflow-hidden p-4">
        {props.children}
      </main>
    </div>
  )
}
